var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zsxx_h5"},[_c('TopTabs',{attrs:{"list":this.$nav8}}),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.obj.content)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }